import * as React from "react";

const AboutSection = () => {
  return (
    <div className="flex flex-col px-16 py-32 w-full text-black bg-gray-200 max-md:py-10 max-md:pb-20 max-md:px-5 max-md:mt-0 max-md:max-w-full">
      <div className="text-3xl font-bold tracking-wider uppercase max-md:mt-10 max-md:max-w-full">
        about us
      </div>
      <div className="mt-8 text-base tracking-wide text-gray-700 max-md:max-w-full">
        Motherland Children Academy is dedicated to cultivating wise and courageous decision-makers through transformative education. As a prestigious CBSE-affiliated school, we prioritize harmonious growth, inspiring students to develop hidden talents and perfect their character. <br /> <br /> Committed to creating responsible citizens, our institution aims to prepare young minds for a prosperous future in the challenging world ahead. With a focus on a well-designed curriculum, we provide a sound education in a co-educational environment, ensuring students develop physically, intellectually, and morally.
      </div>
    </div>
  );
};

const EducationSocietySection = () => {
  const educationSocietyData = [
    {
      name: "Motherland Sec. School",
      description: "(Afiliated to CBSE)",
    },
    {
      name: "Motherland Sr. Sec. School",
      description: "(Hindi & English Medium)",
    },
    {
      name: "Motherland T.t. School",
      description: " ",
    },
    {
      name: "motherland career College",
      description: "B.A. B.Sc. B.C.A.",
    },
    {
      name: "Motherland Girls T.t. College",
      description: "",
    },
  ];

  return (
    <div className="flex flex-col self-stretch px-5 my-auto text-base font-bold text-center  text-stone-500 max-md:mt-10 max-md:max-w-full max-md:py-16">
      <div className="mt-4 max-md:mt-0 text-3xl tracking-wider text-black uppercase max-md:max-w-full">
        our education society
      </div>
      <div className="mt-12 font-medium tracking-wider text-gray-700 max-md:mt-10 max-md:max-w-full">
        Welcome to our school family!
        <br/>
         Explore our umbrella organization and its subdivisions.
      </div>
      <div className="flex gap-32 max-md:gap-5 justify-between mt-12 capitalize tracking-wide text-justify max-md:flex-wrap max-md:mt-10">
        <div>
          {educationSocietyData.slice(0, 3).map((item, index) => (
            <div key={index}>
              <ul>
                <li className="text-black whitespace-nowrap overflow-hidden">{item.name}</li>
              </ul>
              {item.description && (
                <span className="text-xs font-medium text-stone-500">
                  {item.description}
                </span>
              )}
            </div>
          ))}
        </div>
        <div className="flex-auto self-start">
          {educationSocietyData.slice(3).map((item, index) => (
            <div key={index}>
              <ul>
                <li className="text-black overflow-hidden  ">{item.name}</li>
              </ul>
              {item.description && (
                <span className="text-xs font-medium text-stone-500">
                  {item.description}
                </span>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const AboutUs = () => {
  return (
    <div>
      <div className="flex gap-5 max-md:flex-col max-md:gap-0">
        <div className="flex flex-col w-[55%] max-md:ml-0 max-md:w-full">
          <AboutSection />
        </div>
        <div className="flex flex-col ml-5 w-[45%] max-md:ml-0 max-md:w-full max-md:mb-10">
          <EducationSocietySection />
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
